import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel, UIComponentState } from '../uicomponent';
import { HeaderComponentProps } from './headercomponent';
import { HeaderCSSStyle } from './headercss';
import * as React from 'react';
import { Strings } from '../../../utils/resources/strings';
import { LanguageComponent } from './language/languagecomponent';
import { LanguageConst } from '../../../utils/resources/languageconst';
import { RoutingFeatures } from '../../components/navigation/routingfeature';

import './header-style.css';

export class HeaderViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.onHomeClicked = this.onHomeClicked.bind(this);
    }
    draw(props: HeaderComponentProps, state: UIComponentState, cssStyle: HeaderCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
       return (
             <div id="header-wrapper" style={cssStyle.getHeaderContainerCSSStyle()}>
                    {/* <div style={cssStyle.getTitleDivCSSStyle()}>
                        <label style={cssStyle.getTitleCSSStyle()}>{''}</label>
                    </div> */}
                    <div className="login-header-label-wrapper" style={cssStyle.getListCSSStyle()} onClick={this.onHomeClicked}>
                         <label className="login-header-label" style={cssStyle.getAnchorCSSStyle()}>{props.context.getResources().getString(Strings.home)}</label>
                    </div>
                    <div className="login-header-label-wrapper" style={cssStyle.getListCSSStyle()}>
                        <a target="_blank" href={props.context.getConfigurationSettings().getPropertyBasedOnLanguage("AboutAPPURL")}><label className="login-header-label" style={cssStyle.getAnchorCSSStyle()}>{props.context.getResources().getString(Strings.about)}</label></a>
                    </div>
                    <div className="login-header-label-wrapper" style={cssStyle.getListCSSStyle()} onClick={props.onFaqClicked}>
                         <label className="login-header-label" style={cssStyle.getAnchorCSSStyle()}>{props.context.getResources().getString(Strings.faq)}</label>
                    </div>
                    <div className="login-header-label-wrapper" style={Object.assign(cssStyle.getListCSSStyle(), {padding: '0px', paddingLeft: '5px'})}>
                        <LanguageComponent onLanguageChange={(language: LanguageConst) => props.onLanguageChange(language)} context={props.context}/>
                    </div>
             </div>
       );
    }

    onHomeClicked()
    {
        this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.HOME, false);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/header/headerview.tsx